import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import NewFeeReciept from '../../finance/newFeeReciept';
import '../studentProfile.scss';

class PDCDetailsPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pdcDetails: [],
            flattenedData: [],
            grandTotalData: [],
            isEnableReceipt: false,
            receiptData: []
        };
        
        this.dataScrollRef = React.createRef();
        this.grandTotalScrollRef = React.createRef();
    }

    componentDidMount() {
        this.loadPDCDetails();
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.loadPDCDetails();
        }
        
        if (this.state.flattenedData.length > 0 && prevProps.visible !== this.props.visible) {
            setTimeout(() => {
                this.attachScrollListener();
            }, 100);
        }

        // Reload if transactionsData changes
        if (this.props.transactionsData !== prevProps.transactionsData) {
            this.loadPDCDetails();
        }
    }

    componentWillUnmount() {
        this.removeScrollListener();
    }

    loadPDCDetails = () => {
        const { transactionsData } = this.props;
        
        console.log('PDCDetailsPopup - transactionsData:', transactionsData);
        
        // Check if we have API data with collections
        if (transactionsData && transactionsData.collections && Array.isArray(transactionsData.collections)) {
            console.log('PDCDetailsPopup - collections:', transactionsData.collections);
            
            // Filter for Cheque/PDC transactions
            const pdcTransactions = transactionsData.collections.filter(
                txn => {
                    console.log('PDCDetailsPopup - checking transaction:', txn.paymentMode, txn.payment_mode);
                    return txn.paymentMode === 'Cheque' || 
                           txn.paymentMode === 'Post Dated Cheque' || 
                           txn.paymentMode === 'PDC' ||
                           txn.payment_mode === 'Cheque' ||
                           txn.payment_mode === 'Post Dated Cheque' ||
                           txn.payment_mode === 'PDC';
                }
            );

            console.log('PDCDetailsPopup - filtered PDC transactions:', pdcTransactions);

            if (pdcTransactions.length > 0) {
                // Transform API data to our format
                const transformedData = this.transformApiData(pdcTransactions);
                console.log('PDCDetailsPopup - transformedData:', transformedData);
                
                const flattenedData = this.flattenPDCData(transformedData);
                console.log('PDCDetailsPopup - flattenedData:', flattenedData);
                
                const grandTotalData = this.calculateTotals(transformedData);

                this.setState({ 
                    pdcDetails: transformedData,
                    flattenedData,
                    grandTotalData
                }, () => {
                    setTimeout(() => {
                        this.attachScrollListener();
                    }, 100);
                });
                return;
            }
        }

        console.log('PDCDetailsPopup - No PDC data found, setting empty state');
        
        // No PDC data available - set empty state
        this.setState({ 
            pdcDetails: [],
            flattenedData: [],
            grandTotalData: [{ label: 'Grand Total', pdcAmount: 0, gstAmount: 0, totalAmount: 0 }]
        });
    };

    transformApiData = (apiData) => {
        // Group transactions and transform to our structure
        return apiData.map((txn, index) => {
            // Extract fee details from the transaction
            const feeDetails = [];
            
            // Check if transaction has feePaidDetails (API uses this field name)
            if (txn.feePaidDetails && Array.isArray(txn.feePaidDetails)) {
                txn.feePaidDetails.forEach(fee => {
                    feeDetails.push({
                        feeType: fee.feeType || 'N/A',
                        installmentName: fee.paymentTerm || fee.installmentName || 'N/A',
                        pdcAmount: parseFloat(fee.amountPaying || fee.amountPaid || 0),
                        gstAmount: parseFloat(fee.gstPaidNow || fee.gst || 0),
                        totalAmount: parseFloat(fee.amountPaying || fee.amountPaid || 0) + parseFloat(fee.gstPaidNow || fee.gst || 0)
                    });
                });
            } else {
                // Single fee entry if no breakdown provided
                feeDetails.push({
                    feeType: 'Payment',
                    installmentName: 'N/A',
                    pdcAmount: parseFloat(txn.amountPaid || 0),
                    gstAmount: 0,
                    totalAmount: parseFloat(txn.amountPaid || 0)
                });
            }

            return {
                sno: index + 1,
                transactionId: txn.transctionId || txn.receiptNo || `TXN${index + 1}`,
                depositDate: txn.receiptDate || txn.transactionDate || null,
                chequeNo: txn.chequeNo || 'N/A',
                chequeDate: txn.chequeDate || null,
                micrCode: txn.micrCode || 'N/A',
                ifscCode: txn.ifscCode || 'N/A',
                bankName: txn.bankName || 'N/A',
                bankBranch: txn.bankBranchName || txn.bankBranch || 'N/A',
                chequeAmount: parseFloat(txn.amountPaid || 0),
                status: txn.chequeStatus || txn.chequeDDStatus || 'Pending',
                feeDetails: feeDetails,
                originalTransaction: txn // Store the complete original transaction object
            };
        });
    };

    flattenPDCData = (data) => {
        const flattened = [];
        let globalIndex = 0;
        const totalRows = data.reduce((sum, txn) => sum + txn.feeDetails.length, 0);
        
        data.forEach((transaction, txnIndex) => {
            transaction.feeDetails.forEach((fee, index) => {
                flattened.push({
                    ...transaction,
                    ...fee,
                    isFirstRow: index === 0,
                    isLastRow: index === transaction.feeDetails.length - 1,
                    isFirstRowInGroup: globalIndex === 0,
                    isLastRowInGroup: globalIndex === totalRows - 1,
                    isFirstRowInTransaction: index === 0,
                    isLastRowInTransaction: index === transaction.feeDetails.length - 1,
                    rowSpan: index === 0 ? transaction.feeDetails.length : 0,
                    feeDetailIndex: index
                });
                globalIndex++;
            });
        });

        return flattened;
    };

    calculateTotals = (data) => {
        let totalPDCAmount = 0;
        let totalGSTAmount = 0;
        let totalAmount = 0;

        data.forEach(transaction => {
            transaction.feeDetails.forEach(fee => {
                totalPDCAmount += fee.pdcAmount;
                totalGSTAmount += fee.gstAmount;
                totalAmount += fee.totalAmount;
            });
        });

        return [{
            label: 'Grand Total',
            pdcAmount: totalPDCAmount,
            gstAmount: totalGSTAmount,
            totalAmount: totalAmount
        }];
    };

    attachScrollListener = () => {
        this.removeScrollListener();
        
        if (this.grandTotalScrollRef.current) {
            // Get the actual DOM element from DataTable component
            const grandTotalElement = this.grandTotalScrollRef.current.getElement 
                ? this.grandTotalScrollRef.current.getElement() 
                : this.grandTotalScrollRef.current;
            
            const grandTotalWrapper = grandTotalElement.querySelector('.p-datatable-wrapper');
            if (grandTotalWrapper) {
                this.scrollHandler = this.syncScroll.bind(this);
                grandTotalWrapper.addEventListener('scroll', this.scrollHandler);
            }
        }
    };

    removeScrollListener = () => {
        if (this.grandTotalScrollRef.current && this.scrollHandler) {
            // Get the actual DOM element from DataTable component
            const grandTotalElement = this.grandTotalScrollRef.current.getElement 
                ? this.grandTotalScrollRef.current.getElement() 
                : this.grandTotalScrollRef.current;
            
            const grandTotalWrapper = grandTotalElement.querySelector('.p-datatable-wrapper');
            if (grandTotalWrapper) {
                grandTotalWrapper.removeEventListener('scroll', this.scrollHandler);
            }
        }
    };

    syncScroll = (e) => {
        if (this.dataScrollRef.current) {
            // Get the actual DOM element from DataTable component
            const dataElement = this.dataScrollRef.current.getElement 
                ? this.dataScrollRef.current.getElement() 
                : this.dataScrollRef.current;
            
            const dataWrapper = dataElement.querySelector('.p-datatable-wrapper');
            if (dataWrapper) {
                dataWrapper.scrollLeft = e.target.scrollLeft;
            }
        }
    };

    formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    formatCurrency = (value) => {
        if (value === null || value === undefined) return '0';
        return new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(value);
    };

    rowClassName = (rowData) => {
        const classes = [];
        
        // Add class for first row in transaction (to show separator from previous transaction)
        if (rowData.isFirstRowInTransaction) {
            classes.push('transaction-start-row');
        }
        
        // Add class for first row in payment mode group (no top border on very first row)
        if (rowData.isFirstRowInGroup) {
            classes.push('payment-mode-first-row');
        }
        
        // Add thick border on the last row of each payment mode group
        if (rowData.isLastRowInGroup) {
            classes.push('payment-mode-group-last-row');
        }
        
        return classes.join(' ');
    };

    // Body templates for merged columns (only show on first row)
    snoBodyTemplate = (rowData) => {
        if (!rowData.isFirstRow) return '';
        return <span>{rowData.sno}</span>;
    };

    transactionIdBodyTemplate = (rowData) => {
        if (!rowData.isFirstRow) return '';
        return <span>{rowData.transactionId}</span>;
    };

    depositDateBodyTemplate = (rowData) => {
        if (!rowData.isFirstRow) return '';
        return <span>{this.formatDate(rowData.depositDate)}</span>;
    };

    chequeNoBodyTemplate = (rowData) => {
        if (!rowData.isFirstRow) return '';
        return <span>{rowData.chequeNo}</span>;
    };

    chequeDateBodyTemplate = (rowData) => {
        if (!rowData.isFirstRow) return '';
        return <span>{this.formatDate(rowData.chequeDate)}</span>;
    };

    micrCodeBodyTemplate = (rowData) => {
        if (!rowData.isFirstRow) return '';
        return <span>{rowData.micrCode}</span>;
    };

    ifscCodeBodyTemplate = (rowData) => {
        if (!rowData.isFirstRow) return '';
        return <span>{rowData.ifscCode}</span>;
    };

    bankNameBodyTemplate = (rowData) => {
        if (!rowData.isFirstRow) return '';
        return <span>{rowData.bankName}</span>;
    };

    bankBranchBodyTemplate = (rowData) => {
        if (!rowData.isFirstRow) return '';
        return <span>{rowData.bankBranch}</span>;
    };

    chequeAmountBodyTemplate = (rowData) => {
        if (!rowData.isFirstRow) return '';
        return <span>{this.formatCurrency(rowData.chequeAmount)}</span>;
    };

    actionBodyTemplate = (rowData) => {
        if (!rowData.isFirstRow) return '';
        return (
            <Button
                icon="pi pi-eye"
                className="p-button-text p-button-sm"
                onClick={() => {
                    // Use the complete original transaction object from data?.collections
                    const originalTransaction = rowData.originalTransaction;
                    
                    // Pass the complete original object to the receipt
                    this.setState({
                        isEnableReceipt: true,
                        receiptData: originalTransaction
                    });
                }}
                tooltip="View Receipt"
            />
        );
    };

    // Body templates for individual columns (show on all rows)
    feeTypeBodyTemplate = (rowData) => {
        return <span>{rowData.feeType}</span>;
    };

    installmentNameBodyTemplate = (rowData) => {
        return <span>{rowData.installmentName}</span>;
    };

    pdcAmountBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.pdcAmount)}</span>;
    };

    gstAmountBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.gstAmount)}</span>;
    };

    totalAmountBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.totalAmount)}</span>;
    };

    // Grand Total body templates
    grandTotalLabelTemplate = () => {
        return <strong>Grand Total</strong>;
    };

    grandTotalPDCAmountTemplate = (rowData) => {
        return <strong>{this.formatCurrency(rowData.pdcAmount)}</strong>;
    };

    grandTotalGSTAmountTemplate = (rowData) => {
        return <strong>{this.formatCurrency(rowData.gstAmount)}</strong>;
    };

    grandTotalTotalAmountTemplate = (rowData) => {
        return <strong>{this.formatCurrency(rowData.totalAmount)}</strong>;
    };

    render() {
        const { visible, onHide } = this.props;
        const { flattenedData, grandTotalData } = this.state;

        return (
            <Dialog
                header="PDC Details"
                visible={visible}
                onHide={onHide}
                className="pdc-details-popup"
                style={{ width: '95vw', maxWidth: '1600px' }}
                maximizable
                modal
            >
                <div className="payment-mode-table-wrapper">
                    <div ref={this.dataScrollRef} className="data-table-scroll-container">
                        <DataTable
                            value={flattenedData}
                            scrollable
                            scrollHeight="flex"
                            className="payment-mode-table"
                            showGridlines
                            rowClassName={this.rowClassName}
                            emptyMessage="No PDC transactions found"
                        >
                            <Column field="sno" header="S.No" body={this.snoBodyTemplate} bodyClassName="sno-cell" style={{ width: '80px', minWidth: '80px' }} />
                            <Column field="transactionId" header="Transaction ID" body={this.transactionIdBodyTemplate} bodyClassName="transaction-id-cell" style={{ width: '140px', minWidth: '140px' }} />
                            <Column field="depositDate" header="To be Deposit Date" body={this.depositDateBodyTemplate} bodyClassName="receipt-date-cell" style={{ width: '150px', minWidth: '150px' }} />
                            <Column field="chequeNo" header="Cheque No" body={this.chequeNoBodyTemplate} bodyClassName="receipt-no-cell" style={{ width: '150px', minWidth: '150px' }} />
                            <Column field="chequeDate" header="Cheque Date" body={this.chequeDateBodyTemplate} bodyClassName="receipt-date-cell" style={{ width: '130px', minWidth: '130px' }} />
                            <Column field="micrCode" header="MICR Code" body={this.micrCodeBodyTemplate} bodyClassName="receipt-no-cell" style={{ width: '120px', minWidth: '120px' }} />
                            <Column field="ifscCode" header="IFSC Code" body={this.ifscCodeBodyTemplate} bodyClassName="receipt-no-cell" style={{ width: '130px', minWidth: '130px' }} />
                            <Column field="bankName" header="Bank Name" body={this.bankNameBodyTemplate} bodyClassName="receipt-no-cell" style={{ width: '180px', minWidth: '180px' }} />
                            <Column field="bankBranch" header="Bank Branch" body={this.bankBranchBodyTemplate} bodyClassName="receipt-no-cell" style={{ width: '150px', minWidth: '150px' }} />
                            <Column field="chequeAmount" header="Cheque Amount" body={this.chequeAmountBodyTemplate} bodyClassName="total-cell" style={{ width: '140px', minWidth: '140px' }} />
                            <Column field="feeType" header="Fee Type" body={this.feeTypeBodyTemplate} bodyClassName="fee-type-cell" style={{ width: '150px', minWidth: '150px' }} />
                            <Column field="installmentName" header="Installment Name" body={this.installmentNameBodyTemplate} bodyClassName="fee-type-cell" style={{ width: '150px', minWidth: '150px' }} />
                            <Column field="pdcAmount" header="PDC Cheque Amount" body={this.pdcAmountBodyTemplate} bodyClassName="paid-amount-cell" style={{ width: '160px', minWidth: '160px' }} />
                            <Column field="gstAmount" header="GST Amount" body={this.gstAmountBodyTemplate} bodyClassName="paid-amount-cell" style={{ width: '130px', minWidth: '130px' }} />
                            <Column field="totalAmount" header="Total Amount" body={this.totalAmountBodyTemplate} bodyClassName="paid-amount-cell" style={{ width: '140px', minWidth: '140px' }} />
                            <Column header="Action" body={this.actionBodyTemplate} bodyClassName="action-cell" style={{ width: '100px', minWidth: '100px' }} />
                        </DataTable>
                    </div>

                    {/* Grand Total Row */}
                    <div ref={this.grandTotalScrollRef}>
                        <DataTable
                            value={grandTotalData}
                            scrollable
                            scrollHeight="flex"
                            className="payment-mode-grand-total-table"
                            showGridlines
                        >
                            <Column body={() => ''} style={{ width: '80px', minWidth: '80px' }} />
                            <Column body={() => ''} style={{ width: '140px', minWidth: '140px' }} />
                            <Column body={() => ''} style={{ width: '150px', minWidth: '150px' }} />
                            <Column body={() => ''} style={{ width: '150px', minWidth: '150px' }} />
                            <Column body={() => ''} style={{ width: '130px', minWidth: '130px' }} />
                            <Column body={() => ''} style={{ width: '120px', minWidth: '120px' }} />
                            <Column body={() => ''} style={{ width: '130px', minWidth: '130px' }} />
                            <Column body={() => ''} style={{ width: '180px', minWidth: '180px' }} />
                            <Column body={() => ''} style={{ width: '150px', minWidth: '150px' }} />
                            <Column body={() => ''} style={{ width: '140px', minWidth: '140px' }} />
                            <Column body={() => ''} style={{ width: '150px', minWidth: '150px' }} />
                            <Column body={this.grandTotalLabelTemplate} style={{ width: '150px', minWidth: '150px' }} />
                            <Column body={this.grandTotalPDCAmountTemplate} style={{ width: '160px', minWidth: '160px' }} />
                            <Column body={this.grandTotalGSTAmountTemplate} style={{ width: '130px', minWidth: '130px' }} />
                            <Column body={this.grandTotalTotalAmountTemplate} style={{ width: '140px', minWidth: '140px' }} />
                            <Column body={() => ''} style={{ width: '100px', minWidth: '100px' }} />
                        </DataTable>
                    </div>
                </div>
                
                {this.state.isEnableReceipt && (
                    <NewFeeReciept
                        receiptData={this.state?.receiptData}
                        hideFeeReciept={() => {
                            this.setState({
                                isEnableReceipt: false,
                                receiptData: []
                            });
                        }}
                    />
                )}
            </Dialog>
        );
    }
}

export { PDCDetailsPopup };
export default PDCDetailsPopup;
